import EA from '../helpers/init';
import lightGallery from 'lightgallery';
// import lgVideo from 'lightgallery/plugins/video';

export default EA.Methods.lightGallery = ($this) => {
    lightGallery($this.querySelector('.lightgallery'), {
        // plugins: [lgVideo],
        // videojs: true,
        // videojsOptions: {
        //     muted: true,
        // },
        licenseKey: 'F45FC757-F6094154-8C17158C-C0492328',
        download: false,
        speed: 500,
        mobileSettings: {
            showCloseIcon: true,
            controls: false,
        },
    });
};